(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WinesListFooterController', WinesListFooterController);

	WinesListFooterController.$inject = ['WineTable'];

	function WinesListFooterController(WineTable) {

		/* jshint validthis: true */
		var self = this;

		self.table = WineTable;

	}

})();
